import React, { useState, useEffect } from "react";
import { Building2, X, Pencil } from "lucide-react";
import { toast } from "sonner";

export const CostCenterModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialData = null,   // se preenchido → modo edição
}) => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [monthlyBudget, setMonthlyBudget] = useState("");

  const isEdit = !!(initialData && initialData.id);

  useEffect(() => {
    if (isOpen) {
      setCode(initialData?.code || "");
      setName(initialData?.name || "");
      setDescription(initialData?.description || "");
      setMonthlyBudget(
        initialData?.monthly_budget != null && initialData?.monthly_budget !== ""
          ? String(initialData.monthly_budget)
          : ""
      );
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code.trim() || !name.trim()) {
      toast.error("Informe o código e o nome do Centro de Custo.");
      return;
    }

    onSubmit({
      id: initialData?.id || null,
      code: code.trim().toUpperCase(),
      name: name.trim(),
      description: description.trim(),
      monthly_budget: parseFloat(monthlyBudget) || 0.0,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
      <div
        data-testid="modal-cost-center-form"
        className="w-full max-w-md bg-[#131C2E] border border-[#D4AF37]/40 rounded-2xl shadow-[0_0_50px_rgba(212,175,55,0.25)] overflow-hidden flex flex-col"
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800 bg-[#080C14]">
          <div className="flex items-center space-x-2">
            {isEdit ? (
              <Pencil className="w-5 h-5 text-[#D4AF37]" />
            ) : (
              <Building2 className="w-5 h-5 text-[#D4AF37]" />
            )}
            <h3 className="font-serif font-bold text-lg text-white">
              {isEdit ? "Editar Centro de Custo" : "Cadastrar Centro de Custo"}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800"
            data-testid="btn-close-cost-center-modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4 text-xs text-slate-300">

          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block mb-1 font-semibold text-slate-300">Código *</label>
              <input
                data-testid="input-cost-center-code"
                type="text"
                required
                placeholder="CC-06"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 font-mono text-xs"
              />
            </div>

            <div className="col-span-2">
              <label className="block mb-1 font-semibold text-slate-300">Nome do Centro de Custo *</label>
              <input
                data-testid="input-cost-center-name"
                type="text"
                required
                placeholder="Ex: Biblioteca Maçônica"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 text-xs"
              />
            </div>
          </div>

          <div>
            <label className="block mb-1 font-semibold text-slate-300">Orçamento Mensal Previsto (R$)</label>
            <input
              data-testid="input-cost-center-budget"
              type="number"
              step="50"
              placeholder="500"
              value={monthlyBudget}
              onChange={(e) => setMonthlyBudget(e.target.value)}
              className="w-full bg-[#080C14] text-[#D4AF37] font-mono font-bold p-2.5 rounded-xl border border-slate-700 text-xs"
            />
          </div>

          <div>
            <label className="block mb-1 font-semibold text-slate-300">Descrição / Finalidade</label>
            <textarea
              data-testid="input-cost-center-description"
              rows="2"
              placeholder="Finalidade e destinação das despesas deste centro..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full bg-[#080C14] text-white p-2.5 rounded-xl border border-slate-700 text-xs"
            />
          </div>

          <div className="pt-4 border-t border-slate-800 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl bg-slate-800 text-slate-300 hover:text-white font-semibold text-xs"
            >
              Cancelar
            </button>
            <button
              data-testid="btn-submit-cost-center"
              type="submit"
              className="bg-[#D4AF37] hover:bg-[#C5A028] text-slate-950 font-bold px-6 py-2 rounded-xl text-xs uppercase shadow-[0_0_15px_rgba(212,175,55,0.3)]"
            >
              {isEdit ? "Salvar Alterações" : "Salvar Centro de Custo"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};
